import Api from './Api';

export default {
    CheckConneciton(payload) {
        return Api().post('/check_connection', payload)
    },
    CreateConneciton(payload) {
        return Api().post('/create_connection', payload)
    },
    OnCreateBackup(payload) {
        return Api().post('/backup_dump', payload)
    },
}


// WEBPACK FOOTER //
// ./src/services/CheckConnectionService.js